import React from 'react';
import { useMediaQuery } from "@mui/material";
import Header from "../components/Header";
import MobileHeader from "../components/MobileHeader";
import Footer from "../components/Footer";
import PageHeader from "../components/Auth/PageHeader";
import ContactUs from "../components/Contact/ContactUs";

const Contact = () => {
    const isMobile = useMediaQuery('(max-width: 990px)');
    return (
      <div>
          {!isMobile && <Header />} {/* Render Header only on desktop view */}
        {isMobile && <MobileHeader />}{" "}
        {/* Render MobileHeader only on mobile view */}
        <PageHeader
          title="Sign In"
          breadcrumbs={[{ label: "Home", link: "/" }, { label: "Contact Us" }]}
        />
          <ContactUs />
        <Footer />
      </div>
    )
}


export default Contact